// extracted by mini-css-extract-plugin
export default {"yellowButtonContainer":"YellowButton__yellowButtonContainer--4e","yellowButton":"YellowButton__yellowButton--VA"};